import * as React from 'react';
import { Row } from '../Row';
import { selectCheckoutDetails } from '../../../../selectors/publishTerms';
import { useSelector } from 'react-redux';
import { formatPrice } from '../../../../utils/publishTerms';
import { IDetailContainerProps } from './types';

export const DetailContainer = (props: IDetailContainerProps) => {
  const { index } = props;

  const details = useSelector(selectCheckoutDetails);
  const detail = details[index];

  if (!detail) {
    return null;
  }

  const { name, priceDescription, priceNote, discount, discountDescription } = detail;

  const discountValue = discount > 0 ? formatPrice({ price: -discount }) : null;

  return (
    <>
      <Row name={name} value={priceDescription} note={priceNote} />
      {Boolean(discountValue) && <Row isDiscount name={discountDescription || 'Скидка'} value={discountValue} />}
    </>
  );
};
